import React, { ReactElement } from "react";
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from "@mui/material";
import { ReaderData } from "./types";

export default function FoundDevicesList({ data, serial }: { data: ReaderData[], serial: string }): ReactElement | null {
  if (serial === "") {
      return null;
  }
  if (data.length === 0) {
      return (
      <Grid item xs={12}>
          <Typography>No devices found.</Typography>
      </Grid>
      );
  };

  return (
    <Grid item xs={12}>
      <TableContainer sx={{ maxHeight: "25vh" }}>
        <Table stickyHeader size="small" aria-label="found readers table">
          <TableHead>
            <TableRow>
              <TableCell>Serial</TableCell>
              <TableCell>Instance Name</TableCell>
              <TableCell>Instance Address</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {data.map(({ serial, instanceName, instanceAddress }) => (
              <TableRow
                key={serial}
              >
                <TableCell component="th" scope="row">
                  {serial}
                </TableCell>
                <TableCell>{instanceName}</TableCell>
                <TableCell>{instanceAddress}</TableCell>
              </TableRow>
            ))}
            </TableBody>
        </Table>
      </TableContainer> 
    </Grid>
  );
}